import React from "react";
import { useNavigate } from "react-router-dom";

import { saveInstructor } from "../../services/api/user";

import { APP_URL } from "../../util/constants/APP_URL";

import femaleImage from '../../assets/images/FEMALE.png';
import maleImage from '../../assets/images/MALE.png';

const Select = () => {

    const user_data = JSON.parse(localStorage.getItem("asg_user") ?? '{}')

    const navigate = useNavigate()
    const selectInstructor = (instructor: any) => {
        if (user_data) {
            saveInstructor({ instructor, id: user_data.id })
            .then(result => {
                if (result?.status) {
                    const data = {
                        ...user_data,
                        instructor
                    }
                    localStorage.setItem("asg_user", JSON.stringify(data))
                    navigate(APP_URL.QUIZ.MESSAGE)
                }
            })
        }
    }

    return (
        <section className="background-form">
            <div className="flex justify-content-center align-items-center width-full height-full flex-column">
                <div className="select-content">
                    <div className="flex align-items-center">
                        <div className="buble-profile">
                            <img src={maleImage} alt="male" className="male" onClick={() => selectInstructor("MALE")} />
                        </div>
                        <div className="buble-profile">
                            <img src={femaleImage} alt="female" className="female" onClick={() => selectInstructor("FEMALE")} />
                        </div>
                    </div>
                    <div>
                        <p className="text-center ft-EricssonGA628 text-light-green mb-1">
                            ELIGE TU AGENTE
                        </p>
                        <p className="text-center ft-EricssonGA628 text-light-green">
                            INSTRUCTOR
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Select;